export default __webpack_public_path__ + "static/media/venue.6b527175.png";